import { render, staticRenderFns } from "./TemplateSettings.vue?vue&type=template&id=c7b09030&"
import script from "./TemplateSettings.vue?vue&type=script&lang=ts&"
export * from "./TemplateSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports